import { render, staticRenderFns } from "./HcfmArticle.vue?vue&type=template&id=1a4115bf&scoped=true"
import script from "./HcfmArticle.vue?vue&type=script&lang=js"
export * from "./HcfmArticle.vue?vue&type=script&lang=js"
import style0 from "./HcfmArticle.vue?vue&type=style&index=0&id=1a4115bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4115bf",
  null
  
)

export default component.exports